module.exports = __webpack_public_path__ + "assets/869cdfa0f3402f83dcde60458c275cba.mp3";